var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxiconsEducationFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8127 10.7624L15.5627 5.13742C15.3898 5.05153 15.1995 5.00684 15.0064 5.00684C14.8134 5.00684 14.623 5.05153 14.4502 5.13742L6.9502 8.88742L3.2002 10.7624L1.9502 11.3874C1.74405 11.4913 1.5707 11.6502 1.44935 11.8466C1.328 12.043 1.26339 12.2691 1.2627 12.4999V19.9999H3.7627V13.2749L14.4502 18.6249C14.6252 18.7124 14.8127 18.7624 15.0127 18.7624C15.2127 18.7624 15.4002 18.7124 15.5752 18.6249L26.8252 12.9999C27.2502 12.7874 27.5127 12.3499 27.5127 11.8874C27.5127 11.4249 27.2502 10.9874 26.8252 10.7749L26.8127 10.7624Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.25C14.425 21.25 13.8375 21.1125 13.325 20.85L6.25 17.3125V19.3C6.25 21.875 10.15 25 15 25C19.85 25 23.75 21.8875 23.75 19.3V17.3125L16.675 20.85C16.1625 21.1125 15.575 21.25 15 21.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxiconsEducationFilled);
export default __webpack_public_path__ + "static/media/boxicons_education-filled.b4511c7b7524e5b492e1c6d6e58b1379.svg";
export { ForwardRef as ReactComponent };